import classnames from 'classnames'
import parse from 'html-react-parser'
import { Typography } from 'shared/ui'
import { Attachments } from 'widgets/Attachments'
import { type IPreviewBubble } from './Preview'
import styles from './styles.module.scss'

type IPreviewBubbleProps = {
  bubble: IPreviewBubble
}

export const PreviewBubble = ({ bubble }: IPreviewBubbleProps) => {
  const isOutbound = bubble.direction === 'outbound'
  const variant = isOutbound ? 'body-md-regular' : 'body-rg-regular'
  const hasText = Boolean(bubble.html) || Boolean(bubble.parts?.length)
  const hasAttachments = Boolean(bubble.attachments?.length)

  return (
    <div className={classnames(styles.group, { [styles.groupInbound]: !isOutbound })}>
      {hasText && (
        <div
          className={classnames(isOutbound ? styles.bubble : styles.replyBubble, {
            [styles.bubbleRich]: Boolean(bubble.html),
          })}
        >
          <Typography variant={variant} ariaLabel='previewBubble'>
            {bubble.html
              ? parse(bubble.html)
              : bubble.parts?.map((part, index) => (
                  <span
                    key={index}
                    style={
                      part.isPlaceholder ? { color: 'var(--content-neutral-primary)' } : undefined
                    }
                  >
                    {part.text}
                  </span>
                ))}
          </Typography>
        </div>
      )}

      {hasAttachments && (
        <div className={styles.attachments}>
          <Attachments attachments={bubble.attachments ?? []} fullWidth imgFitType={'contain'} />
        </div>
      )}
    </div>
  )
}
